"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperty = exports.isInArray = exports.isNotNull = exports.isNotUndefined = void 0;
function isNotUndefined(x) {
    return x !== undefined;
}
exports.isNotUndefined = isNotUndefined;
function isNotNull(x) {
    return x !== null;
}
exports.isNotNull = isNotNull;
const isInArray = (item, array) => array.includes(item);
exports.isInArray = isInArray;
const getProperty = (obj, property) => obj ? obj[property] : undefined;
exports.getProperty = getProperty;
//# sourceMappingURL=types.js.map